// --- Vendors ---
import gsap from "gsap";
// import Textify from "textify.js"; // <-- Commenté ou retiré si inutile ailleurs
import SplitType from 'split-type';

// --- Components ---
const home = {
    readyFn: function () {
        console.log("Home ready");

        // --- Swiper ---
        const swiperEl = document.querySelector('.swiper');
        if (swiperEl) {
            new Swiper(swiperEl, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 10,
                speed: 400,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    1200: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                }
            });
        }

        // --- Lottie Animation ---
        const lottieEl = document.getElementById('home-lottie');
        if (lottieEl) {
            lottieEl.autoplay = false;
            lottieEl.speed = 0;
            if (lottieEl.pause) lottieEl.pause();

            const triggerEl = document.querySelector('#texte-image') || lottieEl;

            const updateLottieOnScroll = () => {
                if (!triggerEl) return;
                const rect = triggerEl.getBoundingClientRect();
                const viewportBottom = window.innerHeight;
                const sectionMiddle = rect.top + rect.height / 2;

                const shouldPlay = viewportBottom >= sectionMiddle && rect.top <= viewportBottom;

                if (shouldPlay) {
                    lottieEl.classList.add('started');
                    lottieEl.setAttribute("speed", "1");
                    if (lottieEl.play) lottieEl.play();
                } else {
                    lottieEl.speed = 0;
                    if (lottieEl.pause) lottieEl.pause();
                }
            };

            updateLottieOnScroll();
            window.addEventListener('scroll', updateLottieOnScroll, { passive: true });
            window.addEventListener('resize', updateLottieOnScroll);
        }

        // --- Animation Titre (SplitType) ---

        const titre = document.getElementById('h1');

        if (titre) {
            // 1. SAUVEGARDER LE TEXTE ORIGINAL DU SPAN AVANT TOUTE MODIFICATION
            const spanDegradéOriginal = titre.querySelector('.highlighted-text');
            const texteOriginalSauvegarde = spanDegradéOriginal ? spanDegradéOriginal.innerHTML : '';

            // 2. Initialiser SplitType sur le H1 entier
            const myText = new SplitType(titre, { types: 'words, chars' });

            // 3. Réappliquer le texte original dans le span dégradé (pour écraser les spans .char de SplitType)
            if (spanDegradéOriginal) {
                spanDegradéOriginal.innerHTML = texteOriginalSauvegarde;
                // On s'assure que le span est bien un inline-block pour le masque
                spanDegradéOriginal.style.display = 'inline-block';
            }

            // 4. Sélectionner les éléments pour l'animation
            const wrapperDegradé = titre.querySelector('.highlighted-wrapper'); // Assure-toi d'avoir ce wrapper dans ton HTML
            // Si tu n'as pas ajouté le wrapper manuellement, il faut le créer ou cibler le span directement comme masque

            // Si tu n'as pas le wrapper HTML, on va considérer que le span .highlighted-text EST le conteneur du masque
            // Dans ce cas, il faut ajuster le CSS (voir plus bas)

            const toutesLesLettres = titre.querySelectorAll('.char');

            // 5. Lancer l'animation (Reflow)
            void titre.offsetWidth;
            titre.classList.add('is-visible');

            // 6. Animer uniquement les lettres "normales" (celles qui ne sont PAS dans le span dégradé)
            // Car le span dégradé est maintenant un bloc statique animé par le masque CSS
            const lettresNormales = Array.from(toutesLesLettres).filter(char => {
                return !spanDegradéOriginal.contains(char);
            });

            lettresNormales.forEach((char, index) => {
                char.style.transitionDelay = `${index * 40}ms`;
                char.classList.add('revealed'); // Ou gère l'opacité directement via le style
            });

            console.log('🚀 Animation avec espaces restaurés lancée !');
        }
    }
};

export { home };